import { h, render } from "vue";
import Quill from "quill";
import VariableSelector from "../variable-rich-editor/variable-selector.vue";
import { JudgeType, Variable } from "@/types/conditionJudgeNodeType";

const VARIABLE_SELECTOR_REGEX = /\$\{([1235])-([^}]*)\}/g;
const Embed = Quill.import("blots/embed") as any;
const END_REPLY_VARIABLE_BLOT_NAME = "endReplyVariableSelector";
const END_REPLY_VARIABLE_CLASS_NAME = "editor-end-reply-variable-selector";
const END_REPLY_VARIABLE_PLACEHOLDER_CLASS_NAME =
  "editor-end-reply-variable-placeholder";

let hasRegisteredVariableSelectorBlot = false;
let variableProvider: () => Variable[] = () => [];

export const getInfoDefaultValue = () => `\${${JudgeType.INFO}-}`;

export const registerVariableSelectorBlot = (
  getVariables: () => Variable[],
) => {
  variableProvider = getVariables;
  if (hasRegisteredVariableSelectorBlot) return;

  class VariableSelectorBlot extends Embed {
    static blotName = END_REPLY_VARIABLE_BLOT_NAME;
    static tagName = "span";
    static className = END_REPLY_VARIABLE_CLASS_NAME;

    static create(value: string) {
      const node = super.create() as HTMLElement;
      node.setAttribute("data-value", value);

      const type = Number(value.match(/\$\{([^}]+)\}/)?.[1].split("-")[0]);
      const selectorVNode = h(VariableSelector, {
        type,
        defaultValue: value,
        variables: variableProvider() as any,
        onSelect: (selectedValue: string) => {
          node.setAttribute("data-value", selectedValue);
        },
      });

      render(selectorVNode, node);
      return node;
    }

    static value(node: HTMLElement) {
      return node.getAttribute("data-value");
    }
  }

  Quill.register(VariableSelectorBlot);
  hasRegisteredVariableSelectorBlot = true;
};

export const preprocessVariablePlaceholders = (html: string) => {
  return html.replace(VARIABLE_SELECTOR_REGEX, (match) => {
    return `<span class="${END_REPLY_VARIABLE_PLACEHOLDER_CLASS_NAME}" data-value="${match}"></span>`;
  });
};

export const serializeEditorHtmlWithVariables = (editorRoot: HTMLElement) => {
  const tempContainer = document.createElement("div");
  tempContainer.innerHTML = editorRoot.innerHTML;

  tempContainer
    .querySelectorAll(`.${END_REPLY_VARIABLE_CLASS_NAME}`)
    .forEach((node: Element) => {
      const value = node.getAttribute("data-value") || "";
      node.replaceWith(document.createTextNode(value));
    });

  // Quill 会把 embed 内部的块级节点拆出到外层，这里统一清理变量选择器遗留的展示 DOM。
  tempContainer
    .querySelectorAll(".variable-selector-trigger")
    .forEach((node: Element) => {
      node.remove();
    });

  tempContainer.innerHTML = tempContainer.innerHTML.replace(/\uFEFF/g, "");

  return tempContainer.innerHTML;
};

export const insertVariableSelector = (quill: Quill, value: string) => {
  const range = quill.getSelection(true);
  if (!range) return;

  quill.insertEmbed(range.index, END_REPLY_VARIABLE_BLOT_NAME, value);
  quill.insertText(range.index + 1, " ", Quill.sources.API);
  quill.setSelection(range.index + 2, 0);
};
